<template>
	<div class="login bg-blur">
		<div class="regist-contain">
			<el-row>
				<el-col :span="24" class="tit">颐倍康开放平台管理系统</el-col>
			</el-row>
			<div class="regist-form">
				<div class="regist-center">
					<el-form :model="form1" class="demo-ruleForm main-form">
						<el-form-item prop="username1">
							<el-input prefix-icon="el-icon-user" v-model="form1.username1" placeholder="请输入用户名"></el-input>
						</el-form-item>
						<el-form-item prop="password1">
							<el-input prefix-icon="el-icon-lock" type="password" v-model="form1.password1" placeholder="请输入密码"></el-input>
						</el-form-item>
						<el-form-item prop="password2">
							<el-input prefix-icon="el-icon-lock" type="password" v-model="form1.password2" placeholder="请确认密码"></el-input>
						</el-form-item>
						<el-form-item prop="businessname">
							<el-input prefix-icon="el-icon-office-building" v-model="form1.businessname" placeholder="请输入企业名称"></el-input>
						</el-form-item>
						<el-form-item prop="phonenum">
							<el-input prefix-icon="el-icon-mobile-phone" v-model="form1.phonenum" placeholder="请输入手机号"></el-input>
						</el-form-item>
						<el-form-item prop="code" class="code">
							<el-input prefix-icon="el-icon-key" v-model="form1.code1" placeholder="请输入验证码"></el-input>
							<el-button type="primary" @click="onCode" :disabled="disabled=!show">
								<span v-show="show">获取验证码</span>
								<span v-show="!show">{{count}}s 后获取</span>
							</el-button>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" style="width:100%;font-size:18px;" @click="onLog">注册</el-button>
						</el-form-item>
					</el-form>
					<p class="log-on">注册成功 ! 前往 <span @click="logOn">登录</span></p>
				</div>
			</div>
			<el-row class="regist-copy">
				<el-col :span="24">&copy;颐倍康养老服务有限公司</el-col>
			</el-row>
		</div>
	</div>
</template>

<script>
	const TIME_COUNT = 60; //更改倒计时时间
	// import {
	// 	getRegister,
	// 	getLog
	// } from "@/api"
	export default {
		data() {
			return {
				show: true, //初始启用按钮
				count: '', //初始化次数
				timer: null,
				form1: {
					username1: "",
					password1: "",
					password2: "",
					businessname: "",
					phonenum: "",
					code1: ""
				},
			}
		},
		methods: {
			logOn() {
				this.$router.push("/login")
			},
			// 注册
			// getCode() { //生成验证码
			// 	const rancode = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N',
			// 		'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'
			// 	];
			// 	let code="";
			// 	for (var i = 0; i < 4; i++) {
			// 		let index = Math.floor(Math.random() * 36)
			// 		code += rancode[index]
			// 	}

			
			// },
			onCode() { //点击获取验证码
				if (!this.timer) {
					if (this.form1.phonenum !== "") {
						this.count = TIME_COUNT - 1; //从59s开始
						this.show = false;
						this.timer = setInterval(() => {
							if (this.count > 0 && this.count <= TIME_COUNT) {
								this.count--;
							} else {
								this.show = true;
								clearInterval(this.timer); //清除定时器
								this.timer = null;
							}
						}, 1000)
					} else {
						this.show = true;
					}
				}
				// 获取验证码
				const rancode = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N',
					'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'
				];
				let code = "";
				for (var i = 0; i < 4; i++) {
					let index = Math.floor(Math.random() * 36)
					code += rancode[index]
				}
				
				if (this.form1.phonenum === "") {
					this.$message({
						message: "请输入手机号!",
						type: "error"
					});
				}
				// this.getCode()
				// const parameter = {
				// 	num: code,
				// 	phone: this.form1.phonenum
				// }
				// getLog(parameter)
				const data = {
					num: code,
					phone: this.form1.phonenum
				}
				this.$post("api/sendVerificationCode", data).then(res => {
					var success = res.success
					var message = res.message
					if (success == 0) {
						this.$message({
							message: message,
							type: "error"
						});
					} else if (success == 1) {
						this.$message({
							message: message,
							type: "success"
						});
					}

				})
			},

			onLog() { //注册按钮
				const data = {
					business: this.form1.businessname,
					username: this.form1.username1,
					password: this.form1.password1,
					phone: this.form1.phonenum
				}
				this.$post("api/register", data).then(res => {
					var isSuccess = res.success
					var message = res.message
					if (this.form1.username1 === "") {
						this.$message({
							message: "请输入用户名!",
							type: "error"
						});
					} else if (this.form1.password1 === "") {
						this.$message({
							message: "请输入密码!",
							type: "error"
						});
					} else if (this.form1.password2 === "") {
						this.$message({
							message: "请输入确认密码!",
							type: "error"
						});
					} else if (this.form1.businessname === "") {
						this.$message({
							message: "请输入企业名!",
							type: "error"
						});
					} else if (this.form1.code1 === "") {
						this.$message({
							message: "请输入验证码!",
							type: "error"
						});
					} else if (this.form1.password1 != this.form1.password2) {
						this.$message({
							message: "两次输入的密码不一致！",
							type: "success"
						});
					} else if (isSuccess == 0) {
						this.$message({
							message: message,
							type: "error"
						});
					} else if (isSuccess == 1) {
						this.$message({
							message: message,
							type: "success"
						});
						this.show1 = true,
							this.show2 = false,
							this.form1.username1 = "",
							this.form1.password1 = "",
							this.form1.password2 = "",
							this.form1.businessname = "",
							this.form1.phonenum = "",
							this.form1.code1 = ""
					}

				})

			},
		}
	}
</script>

<style scoped="scoped">
	.login {
		height: 100vh;
		position: relative;
		background: #eee;
		background: url("../../public/images/back1.jpg") no-repeat;
		background-size: 100% 100%;
	}

	.regist {
		position: absolute;
		bottom: 22px;
		left: 36px;
		/* right: 240px; */
		font-size: 14px;
	}

	.regist-copy {
		position: absolute;
		bottom: 14px;
		left: 50%;
		transform: translateX(-50%);
		font-size: 16px;
		color: #fff;
	}

	.regist span {
		color: #05abf8;
		cursor: pointer;
	}

	.login-form .demo-ruleForm {
		width: 90%;
		margin: 20px auto;
		background: #fff;
		position: relative;
	}

	.el-form-item .el-input {
		width: 100%;
		font-size: 16px;
	}


	label.el-checkbox.rememberme {
		margin: 0px 0px 15px;
		text-align: left;
	}

	.regist-contain {
		width: 40vw;
		height: 670px;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}

	.regist-form {
		width: 63%;
		height: 520px;
		position: absolute;
		top: 52%;
		left: 50%;
		transform: translate(-50%, -50%);
		border-radius: 10px;
		display: flex;
		overflow: hidden;
		background: rgba(255, 255, 255, 0.3);
		padding: 10px;
	}

	.regist-center {
		width: 100%;
		border-radius: 10px;
		background: #fff;
	}

	.main-form {
		width: 88%;
		margin: 30px auto;
		position: relative;
	}

	.code {
		/* display: flex; */
		/* justify-content: space-between; */
	}

	.code .el-input {
		width: 50%;
		font-size: 14px;
	}

	.tit {
		text-align: center;
		padding: 10px 0;
		color: #fff;
		font-size: 42px;
		font-family: "NSimSun";
	}

	.code .el-button {
		width: 38%;
		font-size: 12px;
		margin-left: 10%;
	}

	.log-on {
		position: absolute;
		bottom: 34px;
		left: 40px;
		font-size: 14px;
	}

	.log-on span {
		color: #05abf8;
		cursor: pointer;
	}

	/* 添加3d背景图效果 */
	.firefly {
		width: 4px;
		height: 4px;
		background: #ecc45e;
		box-shadow: 0px 0px 17px 2px wheat;
		border-radius: 50%;
		position: absolute;
	}
</style>
